module.exports = __webpack_public_path__ + "static/media/Nexa_black.0a61c763.ttf";